import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { SurveyMarksService, ToastService } from '@lassi/webapp-shared';
import { catchError, map, of } from 'rxjs';
import { isStandardPMMarkByNineFig } from './util';

export const isPMMarkGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const surveyMarksService = inject(SurveyMarksService);
  const toast = inject(ToastService);

  const nameOrNineFig = route.paramMap.get('nameOrNineFig');

  if (!nameOrNineFig) {
    return false;
  }

  return surveyMarksService.getSurveyMarkDetails(nameOrNineFig).pipe(
    map((mark) => {
      if (!mark?.mark_number || !isStandardPMMarkByNineFig(mark.mark_number)) {
        toast.showErrorMessage('Not a valid PM mark');
        return false;
      }

      return true;
    }),
    catchError((error) => {
      console.error('Error checking PM mark:', error);
      toast.showErrorMessage('Could not verify mark');
      return of(false);
    }),
  );
};
